import type { JSX } from "react";

const strokeAttributes = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  viewBox: "0 0 24 24",
} as const;

export const SantaFaceIcon = ({
  className,
}: {
  className?: string;
}): JSX.Element => (
  <svg
    {...strokeAttributes}
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path d="M4.5 10.5h15" />
    <path d="M6 10.5c0-4.2 2.6-6.5 6-6.5s6 2.3 6 6.5" />
    <path d="M17.8 10.6c1.9.3 3 1.5 3.2 3.3" />
    <circle cx="21" cy="14.6" r="1.2" />
    <path d="M7.5 12.5v2.5a4.5 4.5 0 0 0 9 0v-2.5" />
    <path d="M9.8 14h.01" />
    <path d="M14.2 14h.01" />
    <path d="M10.4 17.4c.5.4 1 .6 1.6.6s1.1-.2 1.6-.6" />
  </svg>
);
